export default __webpack_public_path__ + "static/media/12.81c55deb.jpeg";